var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('kam-read-only-form',{attrs:{"title":"Incidenten rapport","answers":_vm.answers,"sections":_vm.sections,"media":_vm.media,"site-managers":_vm.siteManagers,"project-leaders":_vm.projectLeaders,"construction-workers":_vm.constructionWorkers,"employees":_vm.employees}})
}
var staticRenderFns = []

export { render, staticRenderFns }